import { render, staticRenderFns } from "./EstoqueGrupoProduto.vue?vue&type=template&id=1d521eb1&scoped=true"
import script from "./EstoqueGrupoProduto.vue?vue&type=script&lang=js"
export * from "./EstoqueGrupoProduto.vue?vue&type=script&lang=js"
import style0 from "./EstoqueGrupoProduto.vue?vue&type=style&index=0&id=1d521eb1&prod&scoped=true&lang=css"
import style1 from "./EstoqueGrupoProduto.vue?vue&type=style&index=1&id=1d521eb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d521eb1",
  null
  
)

export default component.exports